module.exports.PageLinks = {
  about: "about",
  contact: "contact-us",
  solution: "solutions",
  find: "find-me-a-space",
  team: "meet-the-team",
  location: "locations",
  insight: "news",
}
